/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';

const EmbeddedForm = () => {
  useEffect(() => {
    // 1. Create the script element
    const script = document.createElement('script');
    script.src = 'https://js-na2.hsforms.net/forms/embed/v2.js'; // Replace with the form provider's script URL
    script.async = true; // Use async if possible

    // 2. Append the script to the document body
    document.body.appendChild(script);

    // 3. Add an event listener to run code after the script loads
    script.addEventListener('load', () => {
      console.log('Form Load is being called');
      // Assuming the script exposes a global function (e.g., window.createForm)
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '242306328', // Your Portal ID
          formId: '4095f218-0918-4d3a-8263-c7aed2cf8d56', // Your Form ID
          target: '#form-container', // The div where the form will be placed
          region: 'na2',
        });
      }
    });

    // 4. Cleanup function to remove the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []); // The empty dependency array ensures this runs once when the component mounts

  return (
    <div>
      {/* This div is the target container for the form */}
      <div id="form-container" />
    </div>
  );
};

export default EmbeddedForm;
